import { selfAxios } from "@oppein/op-utils";
/**
 * 主合同号标签分页查询
 */
export async function customerMainContactLabelQueryPage(params) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerMainContactLabel/queryPage",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/customerMainContactLabel/queryPage/post.js